import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import { store } from "./redux/store";
import reportWebVitals from "./reportWebVitals";
import { initErrorTracking, trackAccount } from "./utils/errorTracking";

// Before the first render, so a crash while starting is reported too
if (initErrorTracking()) trackAccount(store);

const root = ReactDOM.createRoot(document.getElementById("root"));
<>
  {root.render(
    <div translate="no">
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </div>,
  )}
</>;

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
